import { z } from "zod";

export const healthResponseSchema = z.object({
  status: z.literal("ok"),
  service: z.literal("cafegestor-api"),
  version: z.string(),
  time: z.string(),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;

export const dbHealthResponseSchema = z.object({
  status: z.enum(["ok", "unconfigured", "error"]),
  latencyMs: z.number().optional(),
});

export type DbHealthResponse = z.infer<typeof dbHealthResponseSchema>;
